import React from "react";
import Product1 from '../Img/Product1.png'
import Product2 from '../Img/Product2.png'
import Product3 from '../Img/Product3.png'
import Product4 from '../Img/Product4.png'
import Product5 from '../Img/Product5.png'
import Product6 from '../Img/Product6.png'
import decryptCookieData from "./Functions/decryptCookieData";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// const orders = [
//     {
//         id: "#1234567890",
//         name: "Royal Oud Perfume",
//         amount: 2000, img: Product1,
//         estimated: "23rd Dec to 30th Dec",
//         delivered: ""
//     },
//     { id: "#1234567891", name: "Mystic Blossom Eau de Parfum", amount: 2500, img: Product2, estimated: "24th Dec to 31st Dec", delivered: "" },
//     { id: "#1234567892", name: "Aqua Marine Fragrance", amount: 1800, img: Product3, estimated: "", delivered: "29th Dec" },
//     { id: "#1234567893", name: "Velvet Rose Essence", amount: 3000, img: Product4, estimated: "25th Dec to 1st Jan", delivered: "" },
//     { id: "#1234567894", name: "Amber Wood Luxury Perfume", amount: 2200, img: Product5, estimated: "", delivered: "2nd Jan" }
// ];



const OrderCard = () => {
    const [orders, setOrder] = useState([])
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    const navigate = useNavigate();
    const url = process.env.REACT_APP_API_URL

    const handleProductClick = (id, name) => {
        // navigate(`/product/${name}/${id}`);
        const encryptedName = btoa(encodeURIComponent(name));
        const encryptedId = btoa(encodeURIComponent(id));

        navigate(`/product/${encryptedName}/${encryptedId}`);
    };

    const fetchOrderData = async () => {
        try {
            const response = await fetch(`${url}/payment/${userData.user_id}`);
            const res = await response.json();

            const parsedOrders = res.data.map(order => ({
                ...order,
                cart_products: typeof order.cart_products === "string"
                    ? JSON.parse(order.cart_products)
                    : order.cart_products
            }));

            // ✅ Sort by createdAt (latest first)
            const sortedOrders = parsedOrders.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );

            setOrder(sortedOrders);
        } catch (error) {
            console.error("❌ Error fetching orders:", error);
        }
    };



    useEffect(() => {
        fetchOrderData();
    }, [])
    return (
        <div>
            {orders.map((order, index) => (
                <div key={index} className="order-card-perfume">
                    <div className="order-header-perfume">
                        <div>
                            <p><strong>Total amount:</strong> ₹{order.amountafterdiscount}</p>
                            <p><strong>Order ID:</strong> {order.receipt_id}</p>
                            <p><strong>Order date:</strong> {new Date(order.createdAt).toLocaleDateString("en-IN", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric"
                            })}</p>
                        </div>
                        {
                            order.payment_mode === "Pay now" ? <div>
                                {
                                    order.status === "Success" ? (
                                        <button className="order-sucessbtncss" onClick={() => navigate(`/track/${order.order_id}`)}>
                                            Track Order
                                        </button>
                                    ) : (
                                        <button className="failed-btnbest" >
                                            <i className="fas fa-times-circle"></i>
                                            Failed
                                        </button>
                                    )
                                }
                            </div> :
                            
                            (
                            <div>
                                {
                                    order.orderStatus === "Pending" ? (
                                        <button className="order-sucessbtncss" onClick={() => navigate(`/track/${order.order_id}`)}>
                                            Track Order
                                        </button>
                                    ) : (
                                        <button className="failed-btnbest" >
                                            <i className="fas fa-times-circle"></i>
                                            Failed
                                        </button>
                                    )
                                }
                            </div>
                            )
                        }

                    </div>
                    <hr />
                    <div className="order-delivery-perfume">
                    </div>
                    {/* <div className="order-product-perfume">
                        <img src={`http://localhost:8000${order.product_image}`} alt="Product" className="order-product-image-perfume" />
                        <div className="order-product-details-perfume">
                            <p className="order-product-name-perfume">{order.name}</p>
                            <button className="order-view-product-btn-perfume">View Product</button>
                        </div>
                    </div> */}
                    {order.cart_products && order.cart_products.length > 0 ? (
                        order.cart_products.map((product, idx) => (
                            <div key={idx} className="order-product-perfume">
                                <img
                                    src={`${url}${product.product_image}`}
                                    alt={product.product_name}
                                    className="order-product-image-perfume"
                                />
                                <div className="order-product-details-perfume">
                                    <p className="order-product-name-perfume">{product.product_name}</p>
                                    <p>Price: ₹{product.product_saleprice}</p>
                                    {product.variation_attributes &&
                                        Object.entries(product.variation_attributes).map(([key, value]) => (
                                            <p key={key}><strong>{key}:</strong> {value}</p>
                                        ))
                                    }
                                    <button className="order-view-product-btn-perfume" onClick={() => handleProductClick(product.product_id, product.product_name)} >View Product</button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No products found in this order.</p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default OrderCard;
